(ns frontend.test.view
  (:require
   [common.localization :as loc]
   [common.util :as cu]
   [frontend.ag-grid :as ag-grid]
   [frontend.routing :as routing]
   [frontend.test.alert.view :as alert-test]
   [frontend.test.filters.view :as filters]
   [frontend.test.alerts]
   [frontend.test.allocations]
   [frontend.test.avatar]
   [frontend.test.avatar.view :as avatar-test]
   [frontend.test.breadcrumbs]
   [frontend.test.button.view :as button]
   [frontend.test.chart.view :as chart-test]
   [frontend.test.ck-editor.view :as ck-editor-test]
   [frontend.test.color.view :as color-test]
   [frontend.test.columns-modal.view :as columns-modal-test]
   [frontend.test.date-picker.view :as date-picker]
   [frontend.test.drop-tray.view :as drop-tray-test]
   [frontend.test.datepicker]
   [frontend.test.dropdown-with-sections]
   [frontend.test.entity-types.view :as entity-types-test]
   [frontend.test.event :as event]
   [frontend.test.field-editor.view :as field-editor-test]
   [frontend.test.filter.view :as filter-test]
   [frontend.test.html-table]
   [frontend.test.input-checkbox.view :as input-checkbox-test]
   [frontend.test.input-selection.number :as input-selection-number]
   [frontend.test.input-selection.text-simple :as input-selection-text-simple]
   [frontend.test.input.view :as input-test]
   [frontend.test.kanban-list.view :as kanban-list-test]
   [frontend.test.kanban-v2]
   [frontend.test.kanban-v2.kanban-v2-rf :as kanban-test]
   [frontend.test.labelled-input.view :as labelled-input-test]
   [frontend.test.layout.view :as layout-test]
   [frontend.test.lp-portal.modals.chart-editor.view :as chart-data-editor-test]
   [frontend.test.modal.view :as modal]
   [frontend.test.mention-editor.view :as mention-editor-test]
   [frontend.test.nev-v3.view :as nev-v3]
   [frontend.test.new-buttons]
   [frontend.test.new-components]
   [frontend.test.number-input.view :as number-input]
   [frontend.test.opensearch-cards.view :as opensearch-cards-test]
   [frontend.test.numbers]
   [frontend.test.page-sidebar]
   [frontend.test.page-table]
   [frontend.test.read-only.view :as read-only-test]
   [frontend.test.richtext]
   [frontend.test.search-popover]
   [frontend.test.search-selector.view :as search-selector-test]
   [frontend.test.search.view :as search-test]
   [frontend.test.selection-pill.view :as selection-pill-test]
   [frontend.test.select.view :as select-test]
   [frontend.test.sortable-list :as sortable-list]
   [frontend.test.state-indicator]
   [frontend.test.sub :as sub]
   [frontend.test.survey.timeseries-test :as survey-timeseries-test]
   [frontend.test.tailwind.view :as tailwind-test]
   [frontend.test.text.view :as text-test]
   [frontend.test.ui.alert-list]
   [frontend.test.upload]
   [frontend.test.url-input]
   [frontend.test.validation.view :as validation-test]
   [re-frame.core :as rf]
   [ui.components.select.select :as select]
   [ui.components.text.view :as text]
   [frontend.test.tiptap :as tiptap-test]
   [frontend.test.tiptap-mention :as tiptap-mention-test]))

(def tests
  ;; DO NOT use spaces in path names
  [["button" button/view]
   ["ck-editor" ck-editor-test/view]
   ["color" color-test/view]
   ["columns-modal" columns-modal-test/view]
   ["datepicker" date-picker/view]
   ["drop-tray" drop-tray-test/view]
   ["chart" chart-test/view]
   ["filter" filter-test/view]
   ["filter-editor" filters/view]
   ["modal" modal/view]
   ["select" select-test/view]
   ["layout" layout-test/view]
   ["text" text-test/view]
   ["number-input" number-input/view]
   ["opensearch-cards" opensearch-cards-test/view]
   ["kanban" kanban-test/view]
   ["kanban-list" kanban-list-test/view]
   ["selection-pill" selection-pill-test/view]
   ["field-editor" field-editor-test/view]
   ["labelled-editor" labelled-input-test/view]
   ["mention-editor" mention-editor-test/view]
   ["validation" validation-test/view]
   ["search-selector" search-selector-test/view]
   ["input" input-test/view]
   ["chart-data-editor" chart-data-editor-test/view]
   ["tailwind" tailwind-test/view]
   ["alert" alert-test/view]
   ["avatar" avatar-test/view]
   ["nev-v3" nev-v3/view]
   ["entity-types" entity-types-test/view]
   ["search" search-test/view]
   ["survey-timeseries" survey-timeseries-test/timeseries-survey-test]
   ["input-checkbox" input-checkbox-test/view]
   ["input-number" input-selection-number/view]
   ["input-text-simple" input-selection-text-simple/view]
   ["sortable-list" sortable-list/view]
   ["read-only" read-only-test/view]
   ["tiptap" tiptap-test/view]
   ["tiptap-mention" tiptap-mention-test/view]])

(defn nav-item
  [label _selected?]
  [:li
   [:a
    {:href     (str "/test/" label)
     :on-click (fn [e]
                 (rf/dispatch [::event/set-selected-test label])
                 (js/window.history.pushState nil (pr-str "/test/" label) (str "/test/" label))
                 (routing/notify-route-change-listener nil)
                 (.stopPropagation e)
                 (.preventDefault e))}
    label]])

(defn test-view
  []
  (let [selected-test @(rf/subscribe [::sub/selected-test])
        selected-theme @(rf/subscribe [::sub/selected-theme])
        minimized? @(rf/subscribe [::sub/minimize?])]
    [:div
     {:class "p-4 flex gap-2 relative"}
     [:div
      {:class    "absolute left-0"
       :on-click (fn [_]
                   (rf/dispatch [::event/set-minimized? (not minimized?)]))}
      (if minimized?
        [:i.fal.fa-chevron-right]
        [:i.fal.fa-chevron-left])]
     [:div
      {:class "flex flex-col gap-4 w-3/12"}
      [:button
       {:class "flex border"
        :on-click (fn [_]
                    (routing/set-view! [:companies-grid]))}
       "Go to app"]
      [text/h2 (loc/tr :theme)]
      [select/view
       {:on-change (fn [v]
                     (rf/dispatch [::event/set-theme v]))
        :value     {:value selected-theme
                    :label selected-theme}
        :options   (->> ["zapflow" "zapflow_dark" "zapflow_hc" "teollisuussijoitus" "teollisuussijoitus_dark" "capman" "capman_dark"]
                        (mapv (fn [k]
                                {:value k
                                 :label k})))}]
      (into
       [:ul]
       (->> tests
            (map first)
            (sort)
            (mapv (fn [i]
                    (nav-item i (= i selected-test))))))]
     [:div
      {:class "flex-1"}
      (when-let [view (->> tests
                           (cu/filter-by first selected-test)
                           (first)
                           (second))]
        [view])]]))

(defn test-page
  [route-params]
  (ag-grid/init nil)
  (let [{:keys [test]} route-params]
    (rf/dispatch [::event/set-selected-test test])
    (rf/dispatch [::event/set-theme "zapflow"])
    (fn render-test-page
      [_route-params]
      [test-view])))

(defmethod routing/render-view :test
  [{:keys [route-params]}]
  [test-page route-params])
